module.exports = __webpack_public_path__ + "static/media/47_A.97937557.png";